import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { MdDashboard } from "react-icons/md";
import { LuClock3 } from "react-icons/lu";
import { PiSuitcase } from "react-icons/pi";
import { RiNurseLine } from "react-icons/ri";
import { SlLogout } from "react-icons/sl";
import Widgets from "../../../Widgets";
import { HiArrowsRightLeft } from "react-icons/hi2";
import { CiUser } from "react-icons/ci";
// import { RiNurseLine } from "react-icons/ri";
import { RiArticleLine } from "react-icons/ri";
import { FaRegCopyright } from "react-icons/fa";
import { RiCalendarEventLine } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import { useState, useRef, useEffect } from "react";
import classNames from "classnames";
import { FiMenu } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import strings from "../../../Utils/strings";
import AppDialog from "../../../Widgets/appDialog/appDialog";
import authService from "../../../Services/authService";
import { useMsal } from "@azure/msal-react";
import config from "../../../Config/Config";
import Package from "../../../../package.json";
import clinicService from "../../../Services/clinicService";
import "./SideMenu.css";

function SideMenu() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [collapsed, setCollapsed] = useState(true);
  const [isLogoutDialogVisible, setLogoutDialogVisible] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const [hoverMenuItem, setHoverMenuItem] = useState(null);
  const [Lockhover, setLockhover] = useState(false);
  const sidebarRef = useRef(null);
  const [mobileView, setMobileView] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [isDoctorLogin, setIsDoctorLogin] = useState(false);
  const { instance } = useMsal();
  const location = useLocation();

  useEffect(() => {
    setIsDoctorLogin(authService.getIsDoctorLogin() === "true");
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMobileView(true);
      } else {
        setMobileView(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = (event) => {
    event.stopPropagation();
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setCollapsed(true);
        setLockhover(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Set active menu item based on the current path whenever it changes
    switch (location.pathname) {
      case strings.navigation.dashboard:
        setActiveMenuItem("dashboard");
        break;
      case strings.navigation.appointmentApprove:
        setActiveMenuItem("appointment");
        break;
      case strings.navigation.appointmentRequest:
        setActiveMenuItem("appointmentRequest");
        break;
      case strings.navigation.manageDoctor:
        setActiveMenuItem("manageDoctors");
        break;
      case strings.navigation.report:
        setActiveMenuItem("report");
        break;
      case strings.navigation.viewClinicProfile:
        setActiveMenuItem("clinicProfile");
        break;
      case strings.navigation.doctorProfileView:
        if (authService.getIsDoctorLogin() === "false") {
          setActiveMenuItem("manageDoctors");
        }
        if (authService.getIsDoctorLogin() === "true") {
          setActiveMenuItem("doctorProfile");
        }
        break;
      default:
        setActiveMenuItem(null);
        break;
    }
  }, [location.pathname]);
  const handleSidebarMouseLeave = () => {
    if (!mobileView && !Lockhover) {
      setCollapsed(true);
    }
  };
  const handleMenuItemClick = (menuItemId) => {
    setActiveMenuItem(menuItemId);
  };

  const handleMenuItemHover = (menuItem) => {
    if (!mobileView) {
      setHoverMenuItem(menuItem);
      if (!Lockhover) {
        setCollapsed(false);
      }
    }
  };
  const handleMenuItemLeave = () => {
    if (!mobileView) {
      setHoverMenuItem(null);
      if (!Lockhover) {
        setCollapsed(true);
      }
    }
  };

  const isActive = (path) => location.pathname === path;

  const handleLogoutClick = () => {
    setLogoutDialogVisible(true); // Show the dialog
  };

  const signOutClickHandler = (instance) => {
    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
      console.log(accounts);
      const homeAccountId = accounts[0].homeAccountId;

      const logoutRequest = {
        account: instance.getAccountByHomeId(homeAccountId),
        mainWindowRedirectUri: config.azureRedirect,
      };

      instance.logoutPopup(logoutRequest);
    }
    setIsLoading(false);
  };

  const handleDelFcmToken = async () => {
    try {
      setIsLoading(true)
      let response;
      const localFcmToken = localStorage.getItem(strings.localStorage.fcmToken);
      const body = {
        token: localFcmToken
      }
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.doctorDelFcmToken(body);
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.hospitalDelFcmToken(body);
      }
      return response
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false);
    }
  }

  const handleLogout = async () => {
    const deviceId = localStorage.getItem(strings.localStorage.deviceId);
    const response = await handleDelFcmToken()
    signOutClickHandler(instance);
    localStorage.clear();
    if (deviceId) {
      localStorage.setItem(strings.localStorage.deviceId, deviceId);
    }
    setLogoutDialogVisible(false);
    setIsLoading(true);
  };

  return (


    
    <div className="absolute z-50">
      {isloading ? <Widgets.CircularLoader /> : ""}
      {!collapsed && (
        <div className="md:fixed md:inset-0 md:bg-gray-900 md:bg-opacity-50"></div>
      )}
      <style>
        {`
                    .css-1wvake5.ps-collapsed {
                        width: 60px;
                        min-width: 60px;
                    }
                `}
      </style>
      <Sidebar
        collapsed={collapsed}
        ref={sidebarRef}
        className="flex flex-col h-screen bg-white sidebar"
        onMouseEnter={() => setCollapsed(false)}
        onMouseLeave={handleSidebarMouseLeave}
      >
        <Menu>
        
          <MenuItem
            icon={collapsed ? <FiMenu /> : <RxCross2 />}
            onClick={(event) => toggleSidebar(event)} style={{ cursor: "pointer", zIndex: 1000 }}
            
          ></MenuItem>
          <MenuItem
            icon={<MdDashboard />}
            className={classNames({
              "bg-bgnav text-main":
                activeMenuItem === "dashboard" || hoverMenuItem === "dashboard",
            })}
            onClick={() => {
              handleMenuItemClick("dashboard");
              nav(strings.navigation.dashboard);
            }}
            onMouseEnter={() => handleMenuItemHover("dashboard")}
            onMouseLeave={handleMenuItemLeave}
          >
            {t("dashboard")}
          </MenuItem>

          <MenuItem
            icon={<RiCalendarEventLine />}
            className={classNames({
              "bg-bgnav text-main":
                activeMenuItem === "appointment" ||
                hoverMenuItem === "appointment",
            })}
            onClick={() => {
              handleMenuItemClick("appointment");
              nav(strings.navigation.appointmentApprove);
            }}
            onMouseEnter={() => handleMenuItemHover("appointment")}
            onMouseLeave={handleMenuItemLeave}
          >
            {t("appointment")}
          </MenuItem>

          <MenuItem
            icon={<LuClock3 />}
            className={classNames({
              "bg-bgnav text-main":
                activeMenuItem === "appointmentRequest" ||
                hoverMenuItem === "appointmentRequest",
            })}
            onClick={() => {
              handleMenuItemClick("appointmentRequest");
              nav(strings.navigation.appointmentRequest);
            }}
            onMouseEnter={() => handleMenuItemHover("appointmentRequest")}
            onMouseLeave={handleMenuItemLeave}
          >
            {t("appointmentRequest")}
          </MenuItem>

          {/* <MenuItem icon={<PiSuitcase />} className={classNames({
                        "bg-bgnav text-main": activeMenuItem === "referralTracker"||hoverMenuItem === "referralTracker",
                    })}
                        onClick={() => handleMenuItemClick("referralTracker")}
                        onMouseEnter={() => handleMenuItemHover("referralTracker")}
                        onMouseLeave={handleMenuItemLeave}>{t("Referral Tracker")}</MenuItem> */}
          {!isDoctorLogin && (
            <MenuItem
              icon={<RiNurseLine />}
              className={classNames({
                "bg-bgnav text-main":
                  activeMenuItem === "manageDoctors" ||
                  hoverMenuItem === "manageDoctors",
              })}
              onClick={() => {
                handleMenuItemClick("manageDoctors");
                nav(strings.navigation.manageDoctor);
              }}
              onMouseEnter={() => handleMenuItemHover("manageDoctors")}
              onMouseLeave={handleMenuItemLeave}
            >
              {t("labelManageDoctor")}
            </MenuItem>
          )}

          <MenuItem
            icon={<RiArticleLine />}
            className={classNames({
              "bg-bgnav text-main":
                activeMenuItem === "report" || hoverMenuItem === "report",
            })}
            onClick={() => {
              handleMenuItemClick("report");
              nav(strings.navigation.report);
            }}
            onMouseEnter={() => handleMenuItemHover("report")}
            onMouseLeave={handleMenuItemLeave}
          >
            {t("report")}
          </MenuItem>

          <MenuItem
            icon={<CiUser style={{ strokeWidth: 1 }} />}
            className={classNames({
              "bg-bgnav text-main":
                activeMenuItem === "clinicProfile" ||
                hoverMenuItem === "clinicProfile",
            })}
            onClick={() => {
              handleMenuItemClick("clinicProfile");
              nav(strings.navigation.viewClinicProfile);
            }}
            onMouseEnter={() => handleMenuItemHover("clinicProfile")}
            onMouseLeave={handleMenuItemLeave}
          >
            {t("clinicProfile")}
          </MenuItem>
          {isDoctorLogin && (
            <MenuItem
              icon={<RiNurseLine />}
              className={classNames({
                "bg-bgnav text-main":
                  activeMenuItem === "doctorProfile" ||
                  hoverMenuItem === "doctorProfile",
              })}
              onClick={() => {
                handleMenuItemClick("doctorProfile");
                nav(strings.navigation.doctorProfileView);
              }}
              onMouseEnter={() => handleMenuItemHover("doctorProfile")}
              onMouseLeave={handleMenuItemLeave}
            >
              {t("doctorProfile")}
            </MenuItem>
          )}

          {/* <MenuItem icon={<HiArrowsRightLeft />} className={classNames({
                        "bg-bgnav text-main": activeMenuItem === "doctorReferral"||hoverMenuItem === "doctorReferral",
                    })}
                        onClick={() => handleMenuItemClick("doctorReferral")}
                        onMouseEnter={() => handleMenuItemHover("doctorReferral")}
                        onMouseLeave={handleMenuItemLeave}>{t("Doctor Referral")}</MenuItem> */}

          <MenuItem
            icon={<SlLogout />}
            className={classNames({
              "bg-bgnav text-main":
                activeMenuItem === "logout" || hoverMenuItem === "logout",
            })}
            onClick={() => {
              handleLogoutClick();
            }}
            onMouseEnter={() => handleMenuItemHover("logout")}
            onMouseLeave={handleMenuItemLeave}
          >
            {t("labelLogout")}
          </MenuItem>
        </Menu>
        {collapsed !== true ? (
          <div className="footer absolute bottom-0 left-0 right-0 px-4 py-2 text-xs text-gray-500  border-gray-200">
            <div className="text-sm d-flex text-nowrap footer-margin">
              App Version: <span>{Package.version}</span>
            </div>
            <hr />
            <div className="font-bold text-sm text-black d-flex flex-row text-nowrap">
              &copy; 2024 FVHospital
            </div>
          </div>
        ) : (
          <div className="footer absolute bottom-0 left-0 right-0 px-4 py-2 text-2xl">
            <FaRegCopyright />
          </div>
        )}
      </Sidebar>

      {isLogoutDialogVisible && (
        <AppDialog
          view={
            <p style={{ textAlign: "center" }}>
              {t("sureLogOut")}
            </p>
          }
          setVisibility={setLogoutDialogVisible}
          dialogTitle={t("Logout")}
          dialogPositiveBtnText={t("Yes")}
          dialogNegativeBtnText={t("No")}
          dialogPositiveBtnCall={handleLogout}
          dialogNegativeBtnCall={() => setLogoutDialogVisible(false)}
          widthType={"small"}
        />
      )}
    </div>
  );
}

export default SideMenu;
